<template>
    <div id="stancija" class="overflow-hidden">
        <div class="full-video">
            <video autoplay muted playsinline>
                <source src="../assets/video/chair.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>

            <div class="video-text-bottom-left">
                <p class="video-text-color chair-video" style="text-align:left">{{ webData.chairVideo }}</p>
            </div>
        </div>
        <div class="fullscreen-image">
            <div class="icon-overlay" v-observer>
                <div class="icons-top">
                    <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                            <path fill="#B5BCDB" d="M176 256c44.1 0 80-35.9 80-80s-35.9-80-80-80-80 35.9-80 80 35.9 80 80 80zm352-128H304c-8.8 0-16 7.2-16 16v144H64V80c0-8.8-7.2-16-16-16H16C7.2 64 0 71.2 0 80v352c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-48h512v48c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V240c0-61.9-50.1-112-112-112z"/></svg>
                        <p class="icon-text">{{ webData.villaIcons.i1 }}</p>
                    </div>
                    <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-people-fill" viewBox="0 0 16 16">
                            <path fill="#B5BCDB" d="M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5.784 6A2.24 2.24 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.3 6.3 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1zM4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"/>
                        </svg>
                        <p class="icon-text">{{ webData.villaIcons.i2 }}</p>
                    </div>
                    <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="#B5BCDB" d="M32 384a95.4 95.4 0 0 0 32 71.1V496a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V480H384v16a16 16 0 0 0 16 16h32a16 16 0 0 0 16-16V455.1A95.4 95.4 0 0 0 480 384V336H32zM496 256H80V69.3a21.3 21.3 0 0 1 36.3-15l19.3 19.3c-13.1 29.9-7.6 59.1 8.6 79.7l-.2 .2A16 16 0 0 0 144 176l11.3 11.3a16 16 0 0 0 22.6 0L283.3 81.9a16 16 0 0 0 0-22.6L272 48a16 16 0 0 0 -22.6 0l-.2 .2c-20.6-16.2-49.8-21.8-79.7-8.6L150.2 20.3A69.3 69.3 0 0 0 32 69.3V256H16A16 16 0 0 0 0 272v16a16 16 0 0 0 16 16H496a16 16 0 0 0 16-16V272A16 16 0 0 0 496 256z"/></svg>
                        <p class="icon-text">{{ webData.villaIcons.i3 }}</p>
                    </div>
                </div>
                <div class="icons-bottom">
                    <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="#B5BCDB" d="M183.1 235.3c33.7 20.7 62.9 48.1 85.8 80.5c7 9.9 13.4 20.3 19.1 31c5.7-10.8 12.1-21.1 19.1-31c22.9-32.4 52.1-59.8 85.8-80.5C437.6 207.8 490.1 192 546 192h9.9c11.1 0 20.1 9 20.1 20.1C576 360.1 456.1 480 308.1 480H288 267.9C119.9 480 0 360.1 0 212.1C0 201 9 192 20.1 192H30c55.9 0 108.4 15.8 153.1 43.3zM301.5 37.6c15.7 16.9 61.1 71.8 84.4 164.6c-38 21.6-71.4 50.8-97.9 85.6c-26.5-34.8-59.9-63.9-97.9-85.6c23.2-92.8 68.6-147.7 84.4-164.6C278 33.9 282.9 32 288 32s10 1.9 13.5 5.6z"/></svg>
                        <p class="icon-text">{{ webData.villaIcons.i4 }}</p>
                    </div>
                    <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#B5BCDB" d="M624 416h-16c-26 0-45.8-8.4-56.1-17.9-8.9-8.2-19.7-14.1-31.8-14.1h-16.3c-12.1 0-22.9 5.9-31.8 14.1C461.8 407.6 442 416 416 416s-45.8-8.4-56.1-17.9c-8.9-8.2-19.7-14.1-31.8-14.1h-16.3c-12.1 0-22.9 5.9-31.8 14.1C269.8 407.6 250 416 224 416s-45.8-8.4-56.1-17.9c-8.9-8.2-19.7-14.1-31.8-14.1h-16.3c-12.1 0-22.9 5.9-31.8 14.1C77.8 407.6 58 416 32 416H16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h16c38.6 0 72.7-12.2 96-31.8 23.3 19.7 57.4 31.8 96 31.8s72.7-12.2 96-31.8c23.3 19.7 57.4 31.8 96 31.8s72.7-12.2 96-31.8c23.3 19.7 57.4 31.8 96 31.8h16c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm-400-32v-96h192v96c19.1 0 30.9-6.2 34.4-9.4 9.2-8.5 19.2-14.3 29.6-18.1V128c0-17.6 14.4-32 32-32s32 14.4 32 32v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16c0-52.9-43.1-96-96-96s-96 43.1-96 96v96H224v-96c0-17.6 14.4-32 32-32s32 14.4 32 32v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16c0-52.9-43.1-96-96-96s-96 43.1-96 96v228.5c10.4 3.7 20.4 9.6 29.6 18.1 3.5 3.3 15.3 9.4 34.4 9.4z"/></svg>
                        <p class="icon-text">{{ webData.villaIcons.i5 }}</p>
                    </div>
                    <div class="icon-wrapper">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-controller" viewBox="0 0 16 16">
                            <path fill="#B5BCDB" d="M11.5 6.027a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m2.5-.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m-1.5 1.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1m-6.5-3h1v1h1v1h-1v1h-1v-1h-1v-1h1z"/>
                            <path fill="#B5BCDB" d="M3.051 3.26a.5.5 0 0 1 .354-.613l1.932-.518a.5.5 0 0 1 .62.39c.655-.079 1.35-.117 2.043-.117.72 0 1.443.041 2.12.126a.5.5 0 0 1 .622-.399l1.932.518a.5.5 0 0 1 .306.729q.211.136.373.297c.408.408.78 1.05 1.095 1.772.32.733.599 1.591.805 2.466s.34 1.78.364 2.606c.024.816-.059 1.602-.328 2.21a1.42 1.42 0 0 1-1.445.83c-.636-.067-1.115-.394-1.513-.773-.245-.232-.496-.526-.739-.808-.126-.148-.25-.292-.368-.423-.728-.804-1.597-1.527-3.224-1.527s-2.496.723-3.224 1.527c-.119.131-.242.275-.368.423-.243.282-.494.575-.739.808-.398.38-.877.706-1.513.773a1.42 1.42 0 0 1-1.445-.83c-.27-.608-.352-1.395-.329-2.21.024-.826.16-1.73.365-2.606.206-.875.486-1.733.805-2.466.315-.722.687-1.364 1.094-1.772a2.3 2.3 0 0 1 .433-.335l-.028-.079zm2.036.412c-.877.185-1.469.443-1.733.708-.276.276-.587.783-.885 1.465a14 14 0 0 0-.748 2.295 12.4 12.4 0 0 0-.339 2.406c-.022.755.062 1.368.243 1.776a.42.42 0 0 0 .426.24c.327-.034.61-.199.929-.502.212-.202.4-.423.615-.674.133-.156.276-.323.44-.504C4.861 9.969 5.978 9.027 8 9.027s3.139.942 3.965 1.855c.164.181.307.348.44.504.214.251.403.472.615.674.318.303.601.468.929.503a.42.42 0 0 0 .426-.241c.18-.408.265-1.02.243-1.776a12.4 12.4 0 0 0-.339-2.406 14 14 0 0 0-.748-2.295c-.298-.682-.61-1.19-.885-1.465-.264-.265-.856-.523-1.733-.708-.85-.179-1.877-.27-2.913-.27s-2.063.091-2.913.27"/>
                        </svg>
                        <p class="icon-text">{{ webData.villaIcons.i6 }}</p>
                    </div>
                </div>
                <div class="text-bottom">
                </div>
            </div>
        </div>
        <div class="full-video">
            <video autoplay muted playsinline loop>
                <source src="../assets/video/swimming_in_the_pool.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>

            <div class="video-text-top-right" v-observer>
                <p class="video-text-color center-pool-text" style="text-align:left">{{ webData.insidePoolVideo }}</p>
            </div>
        </div>
        <div class="full-video">
            <video autoplay muted playsinline>
                <source src="../assets/video/katarina_outside.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>

            <div class="video-text-bottom-right" v-observer>
                <p class="video-text-color" style="text-align:right">{{ webData.vineyardVideo }}</p>
            </div>
        </div>
        <div class="split-image-section" style="flex:1;" v-observer>
            <div class="left-half left-half-padding">
                    <div class="left-image merged-with-nature"></div>
                <div class="same-container">
                    <div class="content-with-border">
                        <h3 style="color:#623E2A;">{{ webData.stancijaFrameText.t2 }}</h3>
                        <p style="color:#623E2A;font-weight:500;font-family:revert;">{{ webData.stancijaFrameText.p2 }}</p>
                    </div>
                </div>
            </div>
            <div class="right-half right-half-padding">
                <div class="same-container">
                    <div class="content-with-border">
                        <h3 style="color:#623E2A;">{{ webData.stancijaFrameText.t1 }}</h3>
                        <p style="color:#623E2A;font-weight:500;font-family:revert;">{{ webData.stancijaFrameText.p1 }}</p>
                    </div>
                </div>
                    <div class="right-image privacy-and-nature"></div>
            </div>
        </div>
        <div class="full-video">
            <video autoplay muted playsinline loop>
                <source src="../assets/video/gym.mp4" type="video/mp4">
                Your browser does not support the video tag.
            </video>

            <div class="video-text-top-right" style="background-color:#91572ca6" v-observer>
                <p class="video-text-color jacuzzi-text" style="text-align:left;">{{ webData.jacuzziVideo }}</p>
            </div>
        </div>
        <div class="two-img-container" v-observer>
            <img src="../assets/images/katarina5.jpg" alt="Prva slika" class="responsive-image">
            <img src="../assets/images/katarina6.jpg" alt="Druga slika" class="responsive-image">
        </div>
        <div class="book-now-section">
            <!--<img src="../assets/images/katarina1.jpg" alt="Luxury Vacation" class="book-now-image">-->
            <div class="book-now-image-stancija">
                <div class="contain-scale">
                    <div class="book-now-content-stancija" v-observer>
                        <h1 style="font-weight: lighter;font-size:41px;">{{ webData.bookTitle }}</h1>
                    </div>
                    <router-link to="/book" class="book-now-button" v-observer>{{ webData.bookNow }}</router-link>
                </div>
            </div>
        </div>
        <!--
        <div class="jumbo-header position-relative">
            <div class="position-absolute ds-image-overlay yellow-light flex-column" >
                <div class="matrix-element" v-matrix3d>
                    <div class="matrix-inner">
                        <div v-if="titleLoading" class="slogan-wrapper">
                            <div class="slogan-tans-content">
                                <h1 class="s-base s-base-start s1">{{webData.title[0]}}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="pt-5 pb-5" style="width: 100%; background-color: rgb(117, 106, 85); margin: 50px 0;" v-observer>
            <div class="container">
                <div class="d-flex align-items-center flex-row justify-content-center text-center" style="padding: 12px 0;">
                    <p style="color: #ffffff; font-size: 20px; margin: 0">{{webData.p1}}</p>
                </div>
            </div>
        </div>
        <div class="container-fluid pb-5">
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper text-left position-relative pt-0 pb-0">
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_01.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                    <div class="f-item-50 text-box-right">
                        <p class="text-justify">{{webData.p2}}</p>
                    </div>
                </div>
            </div>
            <div class="position-relative" v-observer>
                <div class="mobile-flex-wrapper-reverse flex-wrapper p-6-wrapper text-left position-relative pt-0 pb-0">
                    <div class="f-item-50 text-box-left">
                        <p class="text-justify">{{webData.p3}}</p>
                    </div>
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_02.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                </div>
            </div>
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper pt-0 pb-0 text-left position-relative">
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_03.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                    <div class="f-item-50 text-box-right">
                        <p class="text-justify">{{webData.p4}}</p>
                    </div>
                </div>
            </div>
            <div class="chess-divider">
                <img src="../assets/static/Katarina_acc_12.jpg" alt="Katarina di Maladel">
            </div>
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper text-left position-relative pt-0 pb-0">
                    <div class="f-item-50 text-box-left">
                        <p class="text-justify">{{webData.p5}}</p>
                    </div>
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_04.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                </div>
            </div>
            <div class="chess-divider">
                <img src="../assets/static/Katarina_acc_13.jpg" alt="Katarina di Maladel">
            </div>
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper text-left position-relative pt-0 pb-0">
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_05.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                    <div class="f-item-50 text-box-right">
                        <p class="text-justify">{{webData.p6}}</p>
                    </div>
                </div>
            </div>
            <div class="chess-divider">
                <img src="../assets/static/Katarina_acc_14.jpg" alt="Katarina di Maladel">
            </div>
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper pt-0 pb-0 text-left position-relative">
                    <div class="f-item-50 text-box-left">
                        <p class="text-justify">{{webData.p7}}</p>
                    </div>
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_06.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                </div>
            </div>
            <div class="chess-divider">
                <img src="../assets/static/Katarina_acc_15.jpg" alt="Katarina di Maladel">
            </div>
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper text-left position-relative pt-0 pb-0">
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_07.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                    <div class="f-item-50 text-box-right">
                        <p class="text-justify">{{webData.p8}}</p>
                    </div>
                </div>
            </div>
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper text-left position-relative pt-0 pb-0">
                    <div class="f-item-50 text-box-left">
                        <p class="text-justify">{{webData.p9}}</p>
                    </div>
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_08.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                </div>
            </div>
            <div class="chess-divider">
                <img src="../assets/static/Katarina_acc_16.jpg" alt="Katarina di Maladel">
            </div>
            <div class="position-relative" v-observer>
                <div class="flex-wrapper p-6-wrapper pt-0 pb-0 text-left position-relative">
                    <div class="img-wrapper f-item-50">
                        <img src="../assets/static/Katarina_acc_09.jpg" class="chess-image" alt="Katarina di Maladel">
                    </div>
                    <div class="f-item-50 text-box-right">
                        <p class="text-justify">{{webData.p10}}</p>
                    </div>
                </div>
            </div>
            <div class="chess-divider">
                <img src="../assets/static/Katarina_acc_17.jpg" alt="Katarina di Maladel">
            </div>
        </div>
        
        <div class="secondary-background">
            <div class="h3-container module-wrapper mobile-wrapper-none" v-observer>
                <div class="p-5-wrapper pt-0 pb-0">
                    <div class="position-relative overflow-hidden img-filter-dark-shadow">
                        <transition name="slideInRight" mode="out-in">
                            <img :key="sliderImage.id" :src="sliderImage.src" :alt="sliderImage.alt" class="wide-img-module">
                        </transition>
                        <div class="position-absolute light-overlay overlay-text acc-custom">
                            <h3>{{webData.t1}}</h3>
                            <div class="spacer-xl"></div>
                            <a @click="$router.replace('book')" style="cursor: pointer;"><i>{{webData.link1}} &#8594;</i></a>
                            <div class="spacer-sm"></div>
                            <a @click="$router.replace('gallery')" style="cursor: pointer;"><i>{{webData.link2}} &#8594;</i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
        <Footer :web-data-global="webData" :key="webData.key"></Footer>
    </div>
</template>

<script>
import Footer from "@/modules/Footer";
import sliderS01 from "@/assets/static/Katarina_acc_10.jpg";
import sliderS02 from "@/assets/static/Katarina_acc_11.jpg";

export default {
    name: "Stancija",
    props: {
        webDataGlobal: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            gallerySlider: [
                {id: 1, alt: 'Katarina di Maladel', src: sliderS01},
                {id: 2, alt: 'Katarina di Maladel', src: sliderS02}
            ],
            sliderImage: {
                id: 1,
                alt: 'Katarina di Maladel',
                src: sliderS01
            },
            titleLoading: false,
            webData: {}
        }
    },
    created () {
        this.webData = this.webDataGlobal.stancija;
    },
    mounted () {
        this.settingUpTitle();
        this.infiniteSlider();
    },
    methods: {
        settingUpTitle () {
            this.titleLoading = this.$store.getters.getTitleLoadingState;
            if (!this.titleLoading) {
                setTimeout(() => {
                    this.settingUpTitle();
                }, 400)
            }
        },
        infiniteSlider () {
            let id = this.sliderImage.id;
            if (id === 2)    this.sliderImage = this.gallerySlider[0];
            else  this.sliderImage = this.gallerySlider[id];
            setTimeout(() => {
                this.infiniteSlider();
            }, 8000)
        }
    },
    components: {Footer}
}
</script>

<style scoped>

#stancija {
    background-color: rgb(239, 235, 229) !important;
}
.full-video {
    width: 100%;
    height: 100vh;
    -o-object-fit: cover;
    object-fit: cover;
    position: relative;
    overflow: hidden;
}
.full-video video {
    width: 100%; 
    height: 100%;
    object-fit: cover;
    transform: scale(1); 
    transform-origin: center center;
}

.smaller-video {
    display: flex;
    width: 100%;
    height: 700px;
    -o-object-fit: cover;
    object-fit: cover;
    position: relative;
    overflow: hidden;
    align-items: center; 
    justify-content: center;
}
.fullscreen-image {
    width: 100%;
    height: 100vh;
    background-size: cover;
    position: relative;
    overflow: hidden;
    background-image: url(../assets/images/katarina2.jpg);
}

.video-text-bottom-left {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: none;
    text-align: center;
    font-size: 2rem;
    width: 100%; 
    padding: 65px;
    background-color: rgba(255, 255, 255, 0.3); 
    margin-bottom: 180px;
}

.video-text-bottom-right {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: none;
    text-align: center;
    font-size: 2rem;
    width: 100%; 
    padding: 65px;
    background-color: #91572ca6; 
    margin-bottom: 180px;
}

.icon-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: rgba(139, 69, 19, 0.5); 
    width: 50%; 
    padding: 20px;
    text-align: center;
    padding-left:100px;
    padding-right:100px;
    padding-bottom:50px;
    min-width: 600px;
    max-width: 780px;
}

@media only screen and (min-width: 1000px) and (max-width: 1400px) {
    .icon-wrapper {
        text-align: center;
        margin-left:50px !important;
        margin-right:50px !important;
        height: 70px !important;
    }
    .icon-overlay {
        /*min-width: 700px;*/
        padding-left:70px;
        padding-right:70px;
    }
}

.icons-top,
.icons-bottom {
    display: flex;
    justify-content: space-around;
    margin-bottom: 10px;
}

.icons-top svg,
.icons-bottom svg {
    width: 30px; 
    height: 30px;
}

.icon-wrapper {
    text-align: center;
    height: 100px !important;
    white-space: nowrap;
    /*line-height: 0;*/
    margin: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 80px !important; 
}

.icon-wrapper svg {
    width: 50px !important; 
    height: 50px !important; 
    max-height: 100%; 
    margin: auto;
}



.icon-text {
    color: #B5BCDB;
}
.video-text-top-right {
    position: absolute;
    top: 0;
    left: 0;
    transform: none;
    text-align: center;
    font-size: 2rem;
    width: 100%; 
    padding: 65px;
    background-color: #52a8bb56; 
    margin-top: 180px;
}

#stancija .jumbo-header {
    background-image: url("../assets/photos/finida_03_lg.jpg");
}
.container-fluid .position-relative {
    width: 100%;
}
.chess-divider {
    width: 100%;
    padding: 1.5rem 5rem;
}
.chess-divider img {
    width: 100%;
    height: auto;
    margin: 0 auto;
}

.privacy-and-nature {
    background-image: url(../assets/images/katarina3.jpg);
}
.merged-with-nature {
    background-image: url(../assets/images/katarina4.jpg);
}

.left-image, .right-image {
    
    height: 500px;
    width: 100%;
    -o-object-fit: cover;
    background-size: cover;
}
.same-container {
    height: 500px; 
    display: flex; 
    flex-direction: column;
}

.two-img-container {
    display: flex;
    justify-content: space-around;
    margin: 10px;
}

.responsive-image {
    max-width: 40%;
    height: auto;
}

.book-now-image-stancija {
        width: 100%;
        height: 700px;
        display: block;
        background-size: cover;
        background-image: url(../assets/images/katarina28.jpeg);
        background-position: center;
}
.book-now-content-stancija h1 {
    font-size: 2em;
    margin-bottom: 20px;
    padding: 100px;
}
.book-now-content-stancija {
    position: absolute;
    top: 0px;
    left: 0px;
    color: black;
    font-weight: lighter !important;
}

.contain-scale {
    background-color: #b5c1ca75;
    padding: 20px;
    text-align: center;
    width: 100%;
    min-height: 100%;
}

@media only screen and (max-width: 600px) {
    .two-img-container {
        flex-direction: column; 
        align-items: center; 
    }

    .responsive-image {
        max-width: 100% !important;
        height: auto;
        padding: 10px;
        margin-bottom: 10px; 
    }
}

@media (min-width: 1000px) {
    .icon-wrapper {
        text-align: center;
        margin-left:50px !important;
        margin-right:50px !important;
        height: 100px !important;
        max-width: 780px !important;
        justify-content: center !important;
        align-items: center !important;
    }
    .left-half-padding, .right-half-padding {
    padding: 5rem;
    }
    .left-half-padding {
        padding-right: 0px;
    }
    .right-half-padding {
        padding-left: 0px;
    }
    .split-image-section {
        margin-top:60px;
    }
    
}

@media (min-width: 1310px) {
    .chess-image {
        width: 100%;
        height: auto;
    }
}
@media (max-width: 1310px) {
    .chess-image {
        width: auto;
        height: auto;
    }
}
@media (max-width: 768px) {
    .icon-overlay {
        width: 100%;
        justify-content: center;
        align-items: center;
        font-size: 13px;
        padding-left: 120px;
        padding-right: 120px;
    }
    .chair-video {
        font-size: 25px !important;
    }
    .center-pool-text {
        text-align: center !important;
    }
    .icon-wrapper svg {
        width: 60px; 
        height: auto;
    }
    .video-text-bottom-right {
        padding: 45px !important;
        padding-left: 20px !important;
    }
    .same-container {
        height: 160px;
    }
    .book-now-image-stancija {
        height: 500px;
    }
    .book-now-content-stancija h1{
        padding: 20px;
    }
    .jacuzzi-text {
        text-align: center !important;
    }
    .video-text-bottom-left, .video-text-bottom-right, .video-text-top-right {
        font-size: 30px !important;
        /*font-family: "Seasons";*/
    }
}

</style>
